export const toCapitalizedWords = name => {
  var words = name.match(/([A-Z]+(?=[A-Z][a-z])|[A-Z]+(?=$)|[A-Z]?[a-z]+|[0-9]+)/g) || []

  return words.map(capitalize).join(' ')
}

export const capitalize = word => {
  return word.charAt(0).toUpperCase() + word.substring(1)
}

export const compareValues = (first, second) => {
  if (typeof first === 'string' && typeof second === 'string') {
    return first === second
  }

  if (typeof first === 'object' && typeof second === 'object' && first !== null && second !== null) {
    return deepEqual(first, second)
  }

  return false
}

const deepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true

  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false
  }

  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)

  if (keys1.length !== keys2.length) return false

  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false
    }
  }

  return true
}

export const formatRow = row => {
  return Object.entries(row)
    .map(([key, value]) => `${toCapitalizedWords(key)}: ${value}`)
    .join(', ')
}
